import getYear from 'date-fns/getYear'
import getMonth from 'date-fns/getMonth'
import getDate from 'date-fns/getDate'

export const CURRENT_DAY = getDate(new Date())
export const CURRENT_YEAR = getYear(new Date())
export const CURRENT_MONTH = ('0' + (getMonth(new Date()) + 1)).slice(-2)
